// extracted by mini-css-extract-plugin
export default {"container":"c0THx3r2r","pullTop":"cjLXTdgGE","tailShadow":"cHNp5OGTe","tail1":"cLW5k2_YU","tail2":"co6Tu53uM","visible":"cWbqW9eEb","left":"cVEMNPZdk"};